import {Button, Drawer} from '@mantine/core';
import {AiOutlinePlus} from 'react-icons/ai';
import {useState} from 'react';
import {CreateForm} from '../forms/CreateForm';

export const AddRecordButton = () => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <Button
                leftSection={<AiOutlinePlus size={16}/>}
                variant="filled"
                onClick={() => setOpened(true)}
            >
                Add Mapping
            </Button>
            
            <Drawer
                opened={opened}
                onClose={() => setOpened(false)}
                title="Create Provider Mapping"
                position="right"
                size="md"
            >
                <CreateForm onSuccess={() => setOpened(false)} />
            </Drawer>
        </>
    );
};